
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.946 8.946C32.464 3.762 28.71 0 24.015 0a8.917 8.917 0 00-7.606 4.284C14.81 1.613 12.064 0 8.985 0 4.29 0 .536 3.761.055 8.945c-.038.23-.194 1.434.28 3.4.685 2.834 2.265 5.412 4.57 7.454L16.4 30l11.694-10.2c2.305-2.043 3.885-4.62 4.57-7.456.474-1.964.318-3.17.28-3.398z","fill":"#0183FE"}})])
          )
        }
      }
    